import request from "@/utils/request";

export const getQiniuToken = (type) => {
  return request.post("/upload/token", { type });
};

/**
 * 获取活动代币记录/货币记录
 */
export const getRecord = (activity, page, size) =>
  request.get(
    `/activity/currency/record?activity=${activity}&page=${page}&size=${size}`
  );
/**
 * 获取活动跑马灯/大奖记录
 */
export const getScrollBar = (key, type) =>
  request.get(`/activity/notice?key=${key}&type=${type}`);

/**
 * 获取好友列表
 */
export const getFriendList = () => request.get(`/activity/friend`);

/**
 * 获取日志
 */
export const getLog = (key, page, size) =>
  request.get(`/activity/log?key=${key}&page=${page}&size=${size}`);
/**
 * 获取数据日志
 */
export const getDateLog = (key, date) =>
  request.get(`/activity/date_log?key=${key}&date=${date}`);
/**
 * 获取 geetest 初始化参数
 */
export const getNECaptchaInitData = (phone, netease_validate) =>
  request.post(`/user/sms2`, {
    phone,
    netease_validate,
  });
/**
 * 获取用户信息
 */
export const getMyInfo = () => {
  return request.get(`/user/my`);
};

export const getNotice = (id) => request.get(`/app/notice`, { params: { id } });

/**
 * 获取公告
 */
export const getNoticeList = (type, page = 1) => {
  return request.get(`/app/notice`, { params: { type, page } });
};

export const getHelpCenter = () => request.get(`/help/center`);

/**
 * 关注某人
 */
export const follow = (id) => request.post(`/api/v2/follow/${id}`);

/**
 * 取消关注
 */
export const unFollow = (id) => request.post(`/api/v2/unfollow/${id}`);

/**
 *
 * 获取信息
 *
 */
export const getMobileTokenInfo = () => request.post(`/mobile/token`);

/**
 * 获取戏感测试结果
 */
export const getDramaticResult = (id) =>
  request.get(`/api/v2/dramatic/test/result`, {
    params: { testId: id },
  });

/**
 * 获取戏感测试结果
 */
export const getShareDramaticResult = (id) =>
  request.get(`/api/v2/dramatic/test/share`, {
    params: { id },
  });

/**
 * 使用上一个戏感测试结果
 */
export const usePrevDramatic = () =>
  request.post(`/api/v2/dramatic/test/use_previous`);

export const getActivityList = () =>
  request.get(`/api/v2/activity/app_activity`);

export const getActivityEasterEgg = () =>
  request.get(`/api/v2/activity/app_activity/easter-egg`);

export const triggerActivityEasterEgg = () =>
  request.post(`/api/v2/activity/app_activity/easter-egg`);
/**
 * 注销账号
 */
export const accountCancel = () => {
  return request.post(`/user/cancel`);
};
/**
 * 获取用户钱包
 */
export const getUserWallet = () => {
  return request.get(`/api/v2/user/wallet`);
};
/**
 * 活动玩法
 *
 */
export const getActivityPlaylist = () => {
  return request.get(`/discover/gift_activity`);
};

export const initUser = (activity_key) => {
  return request.get(`/activity/init?activity_key=${activity_key}`);
};

export const getChestStatus = (activity_id, chest_type, chest_page) =>
  request.get(
    `/activity/chest/status?activity_id=${activity_id}&chest_type=${chest_type}&chest_page=${chest_page}`
  );

export const openChest = (activity_id, id, count, is_extra) =>
  request.post(
    `/activity/chest/open?activity_id=${activity_id}&id=${id}&count=${count}&is_extra=${is_extra}`
  );
/**
 * 建言献策广场
 */

export const getNewHelpCenterList = (type, status, page, size) => {
  return request.get(
    `square/news/feedback?type=${type}&status=${status}&page=${page}&size=${size}`
  );
};
/**
 * 点赞动态
 *
 */
export const like = (id) => {
  return request.post(`news/${id}/like`);
};
/**
 * 获取规则
 *
 */

export const getRule = (activity_id) => {
  return request.get(`activity/content_list?activity_id=${activity_id}`);
};

export const getMysteryInfo = () => request.get(`/mysterious_user/info`);

/**
 * 开轮盘宝箱
 * @param {*} id
 * @param {*} cnt
 * @param {*} room_id
 * @returns
 */
export const openTurntableChest = (id, cnt, room_id) =>
  request.post(`prop/open_chest`, { id, cnt, room_id });

/**
 *
 * @returns 获取幸运用户
 */
export const getTurntableRecord = () =>
  request.get(`prop/room_chest_diamond_lucky_list`);

export const getShop = (activity_id, shop_id) =>
  request.get(
    `/activity/chest/shop?activity_id=${activity_id}&shop_id=${shop_id}`
  );

export const postShop = (activity_id, id, shop_id) =>
  request.post(
    `/activity/chest/shop?activity_id=${activity_id}&id=${id}&shop_id=${shop_id}`
  );

export const getTaskReward = (activity_id, id) =>
  request.post(`activity/task?activity_id=${activity_id}&id=${id}`, null, {
    params: {
      useAppToken: 1,
    },
  });

/**
 * 获取微信配置
 */
export const getWxConfig = (data) => request.post(`/wechat/jsapi_ticket`, data);

export const activityPlay = (activity_key, play_id, data, obj) =>
  request.post(`/activity/${activity_key}/play/${play_id}`, obj, {
    params: data,
  });
export const activityAction = (activity_key, action, data, obj) =>
  request.post(`/activity/${activity_key}/action/${action}`, obj, {
    params: data,
  });
export const getActivityPlayStatistics = (activity_key, play_id, data) =>
  request.get(`/activity/${activity_key}/play/${play_id}/statistics`, {
    params: data,
  });

export const getActivityPlayConfig = (
  activity_key,
  module_key,
  play_way,
  data
) =>
  request.get(`/activity/${activity_key}/play/${module_key}/${play_way}`, {
    params: data,
  });
export const getActivityModuleRank = (activity_key, module_key, data) =>
  request.get(`/activity/${activity_key}/play/${module_key}/rank`, {
    params: data,
  });
export const getActivityActionStatistics = (activity_key, action, data) =>
  request.get(`/activity/${activity_key}/action/${action}`, {
    params: data,
  });

export const getActivityKeyList = (activity_key, play_id, key_code) =>
  request.get(
    `/activity/${activity_key}/play/${play_id}/statistics?key_code=${key_code}`
  );

export const exchangeKey = (activity_key, play_id, id) =>
  request.post(`/activity/${activity_key}/play/${play_id}?id=${id}`);

export const getActivityIndexData = (activity_key) =>
  request.get(`/activity/${activity_key}/action/index`);

export const getExpertAuthStatus = () =>
  request.get(`/famous/authentication/status`);

export const saveFamousAuth = (data) =>
  request.post(`/famous/authentication`, data);

export const getRelation = (relation_id) =>
  request.get(`/api/v2/relation/${relation_id}`);

export const getRecordConfig = (activity_id) =>
  request.get(`/activity/${activity_id}/record_config`);

export const getTabList = (activity_id) =>
  request.get(`/activity/${activity_id}/tab`);

/**
 * 获取宗门树
 */
export const getMentorTree = (uid) =>
  request.get(`/mentor/mentor_tree`, { params: { uid } });

/**
 * 点亮宗门树
 */
export const mentorTreeLight = (light) =>
  request.post(`/mentor/mentor_tree/light`, { light });

/**
 * 邀请点亮宗门树
 */
export const mentorTreeLightShare = (other_uid) =>
  request.post(`/mentor/mentor_tree/share`, { other_uid });

/**
 * 礼包详情
 */
export const getGitPackDetail = (id) =>
  request.get(`/user/recharge/gift-pack/${id}`);

/**
 * 领取免费礼包
 */
export const drawDownGiftPack = () => request.post(`/user/recharge/gift-pack`);

export const childrenDayGift = () =>
  request.post(`/user/recharge/festival-pack`);

/**
 * 获取婚礼特权
 */
export const getWeddingPrivilege = () =>
  request.get(`/api/v2/relation/marriage/privilege`);

export const getHonor = (year, cate) =>
  request.get(`/article/v1/honour`, { params: { year, cate } });

export const getWeddingPackage = (product_id) =>
  request.get(`/api/v2/relation/marriage/wedding/plan/${product_id}`);

export const inviteFriend = (prop_id, friend_uid) =>
  request.post(`/relation/card/apply`, null, {
    params: {
      prop_id,
      friend_uid,
    },
  });

export const getOpenChestRecord = (id) => request.get(`/chest/${id}/record`);

export const getRewardRate = (id) => request.get(`/chest/${id}/rate`);
/**
 * 开萌新宝箱
 */
export const openNewPack = (count) =>
  request.post(`/user/recharge/new-pack`, null, { params: { count } });

export const newHome = (uid) => request.post(`/api/v2/new_home/white`, { uid });

export const newHomeStatus = (uid) =>
  request.get(`/api/v2/new_home/white/info`, { params: { uid } });

export const getUserRiskInfo = (activityKey) =>
  request.get(`/activity/${activityKey}/user`);

export const getVoteList = (params) =>
  request.get(`/article/voice/list`, { params });

export const getTicket = () => request.get(`/article/voice/index`);

export const voteTicket = (id) =>
  request.post(`/article/voice/vote`, { article_id: id });

export const getVoteRecord = () => request.get(`/article/voice/vote/record`);

export const getAuthCondition = () => request.get(`/api/v2/presenter/apply`);

export const getUpMarket = () => request.get(`/api/v2/presenter/shop`);

export const purchaseUpMarket = (id) =>
  request.post(`/api/v2/presenter/shop/purchase`, null, {
    params: { prop_id: id },
  });

export const getUpLottery = () => request.get(`/presenter/lottery`);

export const drawUpLottery = () => request.post(`/presenter/lottery`);

export const getIsUp = () => request.get(`/api/v2/presenter/auth`);

export const getUpActivityList = () =>
  request.get(`/api/v2/presenter/activity_list`);

export const subscribeUpActivity = (id) =>
  request.post(`/api/v2/group/0/activity/${id}/subscribe`);

export const unSubscribeUpActivity = (id) =>
  request.delete(`/api/v2/group/0/activity/${id}/subscribe`);

export const getUpData = () => request.get("/presenter/statistics");

export const getUpRank = (cycle) =>
  request.get("/presenter/rank", { params: { cycle } });

export const getUpEnergy = () => request.get("/presenter/energy");

export const getUpTaskList = () => request.get("/presenter/tasks");

export const doUpTask = (id) =>
  request.post("/presenter/tasks", { task_id: id });

export const getUpEnergyRecord = () => request.get("/presenter/energy/records");

export const getUpMarketRecord = () =>
  request.get("/presenter/lottery/records");

export const getRecommendUpList = () => request.get("/presenter/recommend");

export const updateUpIntro = (params) =>
  request.post("/presenter/intro", params);

export const getUserAddress = (id) =>
  request.get("/user/address", { params: id });

export const getChangeProgress = (id) =>
  request.get("/challenge/progress", { params: id });

export const getChangeIndex = () => request.get("/challenge/index");

export const delUserAddress = (id) =>
  request.delete("/user/address", { data: id });

export const getUserAddressList = () => request.get("/user/address/list");

export const addUserAddress = (params) => request.post("/user/address", params);

export const signChange = (params) => request.post("/challenge/sign", params);

export const getChangeReward = () => request.get("/challenge/rewards");

export const updateUserAddress = (params) =>
  request.patch("/user/address", params);

export const updateChangeAddress = (params) =>
  request.post("/challenge/address", params);

export const getUserSurveyDetail = (id) => {
  return request.get(`/question_survey/info?id=${id}`);
};

export const answerSurveyDetail = (id, token, data) => {
  return request.post(`/question_survey/answer`, {
    question_id: id,
    token: token,
    result: data,
  });
};
export const getMine = () => {
  return request.get(`/article_review/mine`);
};
